var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"social-media-icon",attrs:{"href":_vm.socialMediaUrl(_vm.type),"target":"_blank"}},[_c('img',{staticClass:"social-media-icon__img",attrs:{"src":_vm.socialMediaIcon(_vm.type)}})])}
var staticRenderFns = []

export { render, staticRenderFns }